export const valueNameMap = {
  view_count: '曝光量',
  valid_click_count: '点击量',
  ctr: '点击率',
  valuable_click_count: '可转化点击次数',
  valuable_click_rate: '可转化点击率',
  valuable_click_cost: '可转化点击成本',
  video_play_count: '朋友圈视频播放次数',
  click_image_count: '外层图片点击次数',
  click_detail_count: '文字链点击次数',
  click_head_count: '头像点击次数',
  click_nick_count: '昵称点击次数',
  click_poi_count: '本地门店点击量',
  cpm: '千次展现均价',
  cpc: '点击均价',
  cost: '总消耗',
  wechat_ecoupon_cost: '抵用金消耗（微信广告）',
  wechat_special_cost: '专项金消耗（微信广告）',
  wechat_credit_cost: '账期消耗（微信广告）',
  wechat_tcc_cost: 'TCC赠送金消耗（微信广告）',
  wechat_debt_fixed_cost: '固定金信用金消耗（微信广告）',
  wechat_debt_temp_cost: '临时信用金消耗（微信广告）',
  conversions_count: '目标转化量',
  conversions_rate: '目标转化率',
  conversions_cost: '目标转化成本',
  deep_conversions_count: '深度转化量',
  deep_conversions_rate: '深度目标转化率',
  deep_conversions_cost: '深度转化成本',
  no_interest_count: '不感兴趣点击次数',
  video_outer_play10_count: '10%进度播放量',
  video_outer_play25_count: '25%进度播放量',
  video_outer_play50_count: '50%进度播放量',
  video_outer_play75_count: '75%进度播放量',
  video_outer_play95_count: '95%进度播放量',
  video_outer_play100_count: '100%进度播放量',
  video_outer_play_total_time_count: '视频有效播放总时长',
  video_time_total_count: '视频播放总时长',
  video_outer_play_time_count: '平均有效播放时长',
  video_outer_play_time_avg_rate: '平均有效播放进度',
  video_outer_play_rate: '有效播放率',
  video_outer_play_cost: '有效播放成本',
  video_outer_play_count: '视频有效播放量',
  video_outer_play3s_count: '3s播放完成量',
  video_outer_play5s_count: '5s播放完成量',
  video_outer_play7s_count: '7s播放完成量',
  download_rate: 'APP下载率',
  download_cost: 'APP下载成本',
  download_count: 'APP下载完成量',
  add_desktop_pv: '快应用添加量',
  add_desktop_cost: '快应用添加成本',
  ios_active_count: 'IOS激活次数（微信广告）',
  install_cost: 'APP安装成本',
  install_rate: 'APP安装率',
  click_activated_rate: 'APP点击激活率',
  activated_cost: 'APP激活成本',
  activated_count: 'APP激活总量',
  web_register_count: '注册量（网页）',
  app_register_count: '注册量（APP）',
  app_register_cost: '注册成本（APP）',
  web_register_cost: '注册成本（网页）',
  app_register_rate: '注册率（APP）',
  web_reg_rate: '注册率（网页）',
  app_add_to_cart_count: '加入购物车量（APP）',
  add_to_cart_amount: '加入购物车金额（APP）',
  app_add_to_cart_cost: '加入购物车成本（APP）',
  web_cart_amount: '加入购物车金额（网页）',
  order_count: '下单量',
  web_order_count: '下单量（网页）',
  web_order_rate: '下单率（网页）',
  app_order_rate: '下单率（APP）',
  web_order_cost: '下单成本（网页）',
  order_amount: '订单金额',
  order_unit_price: '下单单价',
  order_roi: '下单花费回报(ROI)',
  app_order_count: '下单量（APP）',
  app_order_cost: '下单成本（APP）',
  app_order_amount: '下单金额（APP）',
  web_order_amount: '下单金额（网页）',
  first_day_order_count: '首日新增下单量',
  first_day_order_amount: '首日新增下单金额',
  add_wishlist_count: '加收藏次数',
  wechat_order_count: '下单量（微信广告）',
  wechat_order_amount: '下单金额（微信广告）',
  wechat_order_roi: '下单ROI（微信广告）',
  web_checkout_count: '付费行为量（网页）',
  web_checkout_cost: '付费行为成本（网页）',
  app_checkout_count: '付费行为量（APP）',
  app_checkout_amount: '付费金额（APP）',
  app_checkout_cost: '付费行为成本（APP）',
  app_checkout_rate: '点击付费行为率（APP）',
  web_checkout_rate: '点击付费行为率（网页）',
  app_activated_checkout_rate: '激活付费行为率（APP）',
  web_activated_checkout_rate: '激活付费行为率（网页）',
  cheout_fd: '首日付费金额',
  cheout_td: '3日付费金额',
  cheout_ow: '7日付费金额',
  cheout_tw: '14日付费金额',
  cheout_om: '30日付费金额',
  cheout_fd_reward: '首日广告花费回报(ROI)',
  cheout_td_reward: '3日广告花费回报(ROI)',
  cheout_ow_reward: '7日广告花费回报(ROI)',
  cheout_tw_reward: '14日广告花费回报(ROI)',
  cheout_om_reward: '30日广告花费回报(ROI)',
  cheout_total_reward: '累计广告花费回报(ROI)',
  first_pay_count: '首次付费行为人数',
  first_day_first_pay_rate: '激活首日付费率(人数)',
  first_pay_cost: '首次付费成本',
  first_memcard_web_count: '首次购买会员人数（网页）',
  first_memcard_app_count: '首次购买会员人数（APP）',
  memcard_web_count: '购买会员次数（网页）',
  memcard_app_count: '购买会员次数（APP）',
  first_memcard_web_rate: '首次购买会员率（网页）',
  first_memcard_app_rate: '首次购买会员率（APP）',
  first_memcard_web_cost: '首次购买会员成本（网页）',
  first_memcard_app_cost: '首次购买会员成本（APP）',
  retention_count: '次日留存人数（APP）',
  retention_rate: '次日留存率（APP）',
  retention_cost: '次日留存成本（APP）',
  effective_leads_count: '有效线索量',
  effective_cost: '有效线索成本',
  effect_leads_purchase_count: '有效线索人数',
  overall_leads_purchase_count: '综合销售线索人数',
  leads_purchase_rate: '付费销售线索转化率',
  leads_purchase_cost: '付费销售线索成本',
  effect_leads_purchase_cost: '有效线索人数成本',
  quest_reservation_count: '销售线索量（微信广告）',
  page_consult_cost: '在线咨询成本',
  effective_consult_count: '有效线索量-咨询',
  potential_consult_count: '潜在客户线索量-咨询',
  page_consult_rate: '在线咨询率',
  tool_consult_count: '附加创意智能咨询量',
  page_reservation_rate: '表单预约率',
  page_reservation_cost: '表单预约成本',
  external_form_reservation_count: '附加创意表单预约量',
  effective_reserve_count: '有效线索量-表单',
  potential_reserve_count: '潜在客户线索量-表单',
  total_reservation_count: '表单预约总量',
  reservation_uv: '表单预约人数',
  valid_leads_uv: '有效线索人数-表单',
  page_phone_call_direct_count: '电话直拨量',
  page_phone_call_direct_cost: '电话直拨成本',
  page_phone_call_back_count: '电话回拨量',
  page_phone_call_back_cost: '电话回拨成本',
  inte_phone_count: '智能电话拨打量',
  phone_call_count: '普通电话拨打量',
  effective_phone_count: '有效线索量-电话',
  potential_phone_count: '潜在客户线索量-电话',
  page_phone_call_direct_rate: '电话直拨率',
  page_phone_call_back_rate: '电话回拨率',
  phone_consult_count: '附加创意智能电话拨打量',
  phone_call_uv: '智能电话拨打人数',
  valid_phone_uv: '有效线索人数-电话',
  potential_customer_phone_uv: '潜在客户人数-电话',
  scan_follow_user_count: '加企业微信客服人数',
  lottery_leads_count: '抽奖线索量',
  lottery_leads_cost: '抽奖线索成本',
  own_page_navigation_count: '自有页导航量',
  own_page_navi_cost: '自有页导航成本',
  platform_page_navigation_count: '平台页导航量',
  platform_page_navigation_cost: '平台页导航成本',
  platform_shop_navigation_count: '平台页门店点击量',
  platform_shop_navigation_cost: '平台页门店页导航成本',
  own_page_coupon_get_count: '自有页领取卡券量',
  own_page_coupon_get_cost: '自有页领取卡券成本',
  platform_coupon_get_count: '平台页领取卡券量',
  platform_coupon_get_cost: '平台页卡券领取成本',
  platform_coupon_click_count: '平台页卡券点击量',
  platform_coupon_get_rate: '平台页卡券领取率',
  landing_page_click_count: '自有页内点击量',
  video_inner_play_count: '平台页视频点击次数',
  lan_button_click_count: '落地页内跳转按钮点击量',
  lan_button_click_cost: '落地页内按钮点击成本',
  cpn_click_button_count: '平台页跳转按钮点击次数',
  cpn_click_button_uv: '平台页跳转按钮点击人数',
  follow_count: '关注量',
  follow_cost: '关注成本',
  forward_count: '转发量',
  forward_cost: '转发成本',
  read_count: '阅读量',
  read_cost: '阅读成本',
  praise_count: '点赞量',
  praise_cost: '点赞成本',
  comment_count: '评论量',
  comment_cost: '评论成本',
  from_follow_uv: '公众号关注量',
  from_follow_cost: '公众号关注成本',
  card_get_count: '卡券领取次数（微信广告）',
  card_use_count: '卡券使用次数（微信广告）',
  canvas_cpn_coupons_get_count: '优惠领取量（微信广告）',
  canvas_cpn_coupons_use_count: '优惠使用量（微信广告）',
  web_application_count: '金融完件量（网页）',
  web_application_cost: '金融完件成本（网页）',
  app_application_count: '金融完件量（APP）',
  app_application_cost: '金融完件成本（APP）',
  pre_cre_web: '金融预授信量（网页）',
  pre_cre_app: '金融预授信量（APP）',
  pre_cre_web_val: '金融预授金额（网页）',
  pre_cre_app_val: '金融预授金额（APP）',
  cre_app: '金融授信量（APP）',
  cre_web_val: '金融授信金额（网页）',
  cre_app_val: '金融授信金额（APP）',
  withdr_dep_web: '金融提现行为量（网页）',
  withdr_dep_app: '金融提现行为量（APP）',
  withdr_dep_web_val: '金融提现金额（网页）',
  withdr_dep_app_val: '金融提现金额（APP）',
  web_apply_uv: '金融完件人数（网页）',
  web_credit_uv: '金融授信人数（网页）',
  app_apply_uv: '金融完件人数（APP）',
  app_pre_credit_uv: '金融预授信人数（APP）',
  app_credit_uv: '金融授信人数（APP）',
  app_withdraw_uv: '金融提现行为人数（APP）',
  cre_web_cost: '金融授信成本（网页）',
  cre_app_cost: '金融授信成本（APP）',
  pre_cre_web_cost: '金融预授信成本（网页）',
  pre_cre_app_cost: '金融预授信成本（APP）',
  coupon_click_count: '（游戏）礼包兑换按钮点击',
  coupon_issue_count: '（游戏）礼包（券）发放量',
  coupon_get_count: '（游戏）礼包（券）领取量',
  game_create_role_count: '游戏内创建角色量',
  game_authorize_count: '游戏授权量',
  game_tutorial_finish_count: '游戏完成新手教程量',
  wechat_app_register_uv: '微信小游戏注册人数',
  ad_pur_val_web: '广告变现金额（网页）',
  ad_pur_val_app: '广告变现金额（APP）',
  arppu_cost: '付费ARPPU（APP）',
  arpu_cost: '付费ARPU（APP）',
  web_arppu_cost: '付费ARPPU（网页）',
  web_arpu_cost: '付费ARPU（网页）',
  app_ad_pur_arpu_cost: '广告变现ARPU（APP）',
  web_ad_pur_arpu_cost: '广告变现ARPU（网页）',
  ka_download_count: 'APP下载完成量',
  ka_activated_count: 'APP激活总量',
  ka_activated_rate: 'APP下载激活率',
  install_count: 'APP安装量',
  web_register_uv: '注册人数（网页）',
};
